// extracted by mini-css-extract-plugin
export default {"menu_items_layout":"menuitems_menu_items_layout__rWvau","menu_items_link":"menuitems_menu_items_link__QwZp8"};